import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Users, Heart, Calendar } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function WhyThisMarket() {
  const { lang } = useLang();

  const reasons = lang === 'ru' ? [
    {
      icon: TrendingUp,
      text: 'Рынок растёт',
    },
    {
      icon: Users,
      text: 'Дети рождаются каждый день',
    },
    {
      icon: Heart,
      text: 'Эмоции — постоянный спрос',
    },
    {
      icon: Calendar,
      text: 'Стабильный спрос круглый год',
    },
  ] : [
    {
      icon: TrendingUp,
      text: 'El mercado crece',
    },
    {
      icon: Users,
      text: 'Los niños nacen cada día',
    },
    {
      icon: Heart,
      text: 'Las emociones — demanda constante',
    },
    {
      icon: Calendar,
      text: 'Demanda estable todo el año',
    },
  ];

  const title = lang === 'ru' ? 'Почему этот рынок?' : '¿Por qué este mercado?';

  return (
    <section className="relative py-16 md:py-20 px-6 overflow-hidden">
      <div
        className="absolute inset-0 opacity-30"
        style={{ background: 'radial-gradient(circle at 50% 50%, rgba(212,175,55,0.1) 0%, transparent 70%)' }}
      />
      
      <div className="max-w-5xl mx-auto relative z-10">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-5xl font-black font-heading text-center gold-text mb-12"
        >
          {title}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reasons.map((reason, i) => {
            const Icon = reason.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: i % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.1 }}
                className="glass rounded-2xl p-6 md:p-8 flex items-center gap-4 hover:scale-105 transition-transform duration-300"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{
                    background: 'linear-gradient(135deg, rgba(212,175,55,0.2) 0%, rgba(212,175,55,0.05) 100%)',
                  }}
                >
                  <Icon size={26} className="text-[#D4AF37]" />
                </div>
                <p className="text-white font-semibold text-lg md:text-xl">
                  {reason.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
